import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

/**
 * React Query key factory for the per-org plugin list. Convention from
 * the Phase 2 contract: list keyed on `['org-plugins', orgId]`.
 */
export function orgPluginsQueryKey(organizationId: string) {
  return ['org-plugins', organizationId] as const;
}

export function useOrgPlugins(organizationId: string | null | undefined) {
  return useQuery({
    queryKey: orgPluginsQueryKey(organizationId ?? ''),
    queryFn: () => api.getOrgPlugins(organizationId!),
    enabled: !!organizationId,
  });
}
